import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {CircularProgress, Tooltip} from "@mui/material";
import {CloudDownload} from "@mui/icons-material";

import PrestashopDisabledButton from "./PrestashopDisabledButton";

import importFeed from 'api/feed/importFeed';

import {primaryColor} from "assets/jss/main";
import {FeedListContext} from "views/marketplace/retailer/feed/FeedListContext";

ImportButton.propTypes = {
    feed: PropTypes.shape({
        id: PropTypes.string.isRequired,
        dataType: PropTypes.string.isRequired,
        transportType: PropTypes.string.isRequired,
        mapper: PropTypes.string,
        configuration: PropTypes.object,
    }).isRequired,
};

function ImportButton({feed}) {
    const [loading, setLoading] = React.useState(false);
    const {refreshFeeds} = React.useContext(FeedListContext);

    if (!(feed.mapper || feed.transportType === 'api')) {
        return null;
    }

    if (feed.dataType === 'prestashop' &&
        (feed.configuration.locales && feed.configuration.locales.length > 1) &&
        (!feed.configuration.mappedLocales || (feed.configuration.mappedLocales && feed.configuration.mappedLocales.length < 1))
    ) {
        return <PrestashopDisabledButton />
    }

    return (
        <div onClick={() => {
            setLoading(true)
            importFeed(feed.id).then(() => refreshFeeds()).finally(() => setLoading(false))
        }}>
            <Tooltip title={<FormattedMessage id='feed.list.table.tooltip.import' />}>
                {loading ? (
                    <CircularProgress size={20} />
                ) : (
                    <CloudDownload style={{
                        color: primaryColor,
                        cursor: "pointer"
                    }} />
                )}
            </Tooltip>
        </div>
    );
}

export default ImportButton;
